import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Button, Typography, Paper } from "@mui/material";
import globals from "../globals";
import { styled } from "@mui/material/styles";
import { height, sizeHeight, Stack, width } from "@mui/system";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Container from "@mui/material/Container";
import CourseCarousel from "../components/carousels/courseCarousel";
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import YoutubeCarousel from "../components/carousels/youtubeCarousel";
import TestimonialsCarousel from "../components/carousels/testimonialsCarousel";
import BlogImageList from "./blogImageList";
import { useNavigate } from "react-router-dom";
import WhoWeAre from "../components/about_us_blocks/who_we_are";
import WhyChooseUs from "../components/about_us_blocks/why_choose_us";
import { useAuth } from "../context/AuthContext";
import HomePageBanner from "./home_banner";

const RegButton = styled(Button)(() => ({
    color: globals.colors.backgroundColor,
    backgroundColor: globals.colors.lightRed,
    '&:hover': {
        backgroundColor: globals.colors.darkRed,
        color: globals.colors.backgroundColor,
    },
    '&.Mui-selected': {
        color: globals.colors.lightRed,
    },
}))

export default function Home() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [suggestedCourses, setSuggestedCourses] = useState([]);


    useEffect(() => {
        fetch(globals.apiUrl + '/courses/suggested', {
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                //console.log('data', data)
                setSuggestedCourses(data);
            });
    }, []);



    return (
        <div>
            <HomePageBanner backgroundColor={globals.colors.lightRed} text={'🐻 Безплатен уебинар: Да опознаем мечките 🐻'} textColor={globals.colors.backgroundColor} link={'/webinar/wwf'} />
            <Container>
                {/* First (Title) Component */}
                <Grid container justifyContent={'space-evenly'}>
                    <Grid item display="flex" justifyContent="center" alignItems="center" xs={12} sm={6} justifySelf={'auto'} direction={'column'}>
                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: "bold", alignSelf: "center", fontSize: globals.text.title.fontSize }}>eAcademiaBg</Typography>
                        <Typography sx={{ color: globals.colors.textColor, alignSelf: "center", fontSize: globals.text.subtitle.fontSize, fontWeight: "bold" }}>Онлайн уроци за всеки</Typography>
                        {!user && <RegButton variant="contained" onClick={() => navigate('/register')} sx={{ width: 250, height: 50, alignSelf: "center", mt: 3, fontSize: 20, fontWeight: "bold" }}>Регистрирай се!</RegButton>}
                        <Typography sx={{ color: globals.colors.darkBlue, alignSelf: "center", textAlign: 'center', mt: 3, fontSize: 18 }}>
                            В <strong>eAcademiaBg</strong> предлагаме <strong>индивидуални онлайн уроци
                                и курсове</strong>, съобразени с <strong>нуждите на всеки ученик</strong>, <strong>достъпни отвсякъде</strong> и в <strong>удобно за теб време</strong>.</Typography>
                    </Grid>
                    <Grid item display="flex" justifyContent="center" alignItems="center" xs={12} sm={6} width={{ xs: 1, md: 0.4 }} justifySelf={'auto'} direction={'column'}>
                        <a href='/'><img alt='Лого на eAcademiaBg - онлайн училище за всеки'
                            title='eAcademiaBg – Модерна образователна платформа'
                            style={{ overflow: 'hidden', maxWidth: "100%", height: "auto" }}
                            src='eacademiabg-onlayn-uchilishte-za-vseki.webp'
                            fetchpriority="high" /></a>
                    </Grid>
                </Grid>

                {/* Card 1 Courses */}
                <Grid container justifyContent={'center'} sx={{ mt: 5, gap: 15 }}>
                    <Grid display="flex" justifyContent="center" alignItems="center" size="grow" flexDirection={'row'}>
                        <Stack direction={'column'}>
                            <img onClick={() => navigate('/courses')} src="eacademiabg-kursove.webp" loading="lazy" decoding="async"
                                alt="Илюстрация на сова с лаптоп и надпис „Курсове“"
                                title="Онлайн курсове в eAcademiaBg"
                                style={{ cursor: "pointer" }} height="300" />
                            <Box
                                sx={{
                                    display: 'flex',
                                    bgcolor: globals.colors.lightRed,
                                    height: 70,
                                    width: 'inherit',
                                    '&:hover': {
                                        background: globals.colors.darkRed,
                                        cursor: "pointer"
                                    }
                                }}
                                onClick={() => navigate('/courses')}
                            >
                                <Typography variant="h6" sx={{ color: globals.colors.backgroundColor, alignSelf: 'center', px: 10, textTransform: 'uppercase', fontWeight: 'bold' }}>Заведи ме</Typography>
                            </Box>
                        </Stack>
                    </Grid>

                    {/* Card 2 Teachers */}
                    <Grid display="flex" justifyContent="center" alignItems="center" size="grow" flexDirection={'row'}>
                        <Stack direction={'column'}>
                            <img onClick={() => navigate('/instructors')} src="eacademiabg-uchiteli.webp" loading="lazy" decoding="async"
                                alt="Илюстрация на сова с академическа шапка и надпис „Учители“"
                                title="Запознай се с учителите на eAcademiaBg"
                                style={{ cursor: "pointer" }} height="300" />
                            <Box
                                sx={{
                                    display: 'flex',
                                    bgcolor: globals.colors.darkBlue,
                                    height: 70,
                                    width: 'inherit',
                                    '&:hover': {
                                        background: globals.colors.lightBlue,
                                        cursor: "pointer"
                                    }
                                }}
                                onClick={() => navigate('/instructors')}
                            >
                                <Typography variant="h6" sx={{ color: globals.colors.backgroundColor, alignSelf: 'center', px: 10, textTransform: 'uppercase', fontWeight: 'bold' }}>Заведи ме</Typography>
                            </Box>
                        </Stack>
                    </Grid>

                    {/* Card 3 Free Materials  */}
                    <Grid display="flex" justifyContent="center" alignItems="center" size="grow" flexDirection={'row'}>
                        <Stack direction={'column'}>
                            <img onClick={() => navigate('/coming-soon')} src="eacademiabg-bezplatni-materiali.webp" loading="lazy" decoding="async"
                                alt="Илюстрация на кутия с учебни материали и надпис „Безплатни материали“"
                                title="Безплатни образователни материали от eAcademiaBg"
                                style={{ cursor: "pointer" }} height="300" />
                            <Box
                                sx={{
                                    display: 'flex',
                                    bgcolor: globals.colors.lightRed,
                                    height: 70,
                                    width: 'inherit',
                                    '&:hover': {
                                        background: globals.colors.darkRed,
                                        cursor: "pointer"
                                    }
                                }}
                                onClick={() => navigate('/zheravko-dragomanski-2')}
                            >
                                <Typography variant="h6" sx={{ color: globals.colors.backgroundColor, alignSelf: 'center', px: 10, textTransform: 'uppercase', fontWeight: 'bold' }}>Заведи ме</Typography>
                            </Box>
                        </Stack>
                    </Grid>
                </Grid>

                {/* About us */}
                <WhoWeAre />

                {/* Защо да избереш eAcademiaBg? */}
                <WhyChooseUs />

                {/* Carousel with Testimonials */}
                <Grid container justifyContent='space-evenly' sx={{ mt: 5 }} justifyItems={'center'}>
                    <Stack>
                        <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    width: 1,
                                    height: 90,
                                }}>
                                <Grid container just sx={{ mt: 3 }} justifyContent={'center'}>
                                    <Grid>
                                        <Typography variant='h2' sx={{ color: globals.colors.lightRed, fontWeight: 'bold', fontSize: 35 }}><strong>Другите за нас</strong></Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                        <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'} sx={{ mb: 8 }}>
                            < TestimonialsCarousel />
                        </Grid>
                    </Stack>
                </Grid>



                {/* Carousel with courses */}
                {suggestedCourses.length > 0 &&
                    <Grid container justifyContent='space-evenly' justifyItems={'center'}>
                        <Stack>
                            <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        width: 1,
                                        height: 90,
                                        bgcolor: globals.colors.darkBlue,
                                        borderRadius: 3,
                                        mb: 5,
                                    }}>
                                    {/* Change icon depending on seasons */}
                                    {/* <WbSunnyIcon sx={{ justifySelf: 'center', fontSize: 60, color: globals.colors.darkYellow, zIndex: 10, position: 'absolute' }} /> */}
                                    <Grid container sx={{ mt: 3 }} justifyContent={'center'} alignItems={'center'}>
                                        <Grid item>
                                            <Typography variant="h1" sx={{ display: 'flex', color: globals.colors.backgroundColor, alignSelf: 'center', px: 3, fontWeight: 'bold', mb: 5, fontSize: 40 }}>Курсове</Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                            <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                                <CourseCarousel courses={suggestedCourses} />
                            </Grid>
                        </Stack>
                    </Grid>
                }

                {/* Carousel with Youtube videos
            <Grid container justifyContent='space-evenly' sx={{ mt: 10 }} justifyItems={'center'}>
                <Stack>
                    <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                        <Box
                            sx={{
                                display: 'flex',
                                width: 1,
                                minHeight: 90,
                                bgcolor: globals.colors.lightGray,
                                borderRadius: 3,
                            }}>
                            <Grid container just sx={{ mt: 3 }} justifyContent={'center'}>
                                <Grid>
                                    <Typography variant="h4" sx={{ display: 'flex', color: globals.colors.lightRed, textAlign: 'center', textTransform: 'uppercase', fontWeight: 'bold' }}>Нашите Учители</Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                    <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                        < YoutubeCarousel />
                    </Grid>
                </Stack>
            </Grid> */}

                {/* Blog Gallery
            <Grid container justifyContent='space-evenly' justifyItems={'center'}>
                <Stack>
                    <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                        <Box
                            sx={{
                                display: 'flex',
                                width: 1,
                                height: 90,
                            }}>
                            <Grid container just sx={{ mt: 3 }} justifyContent={'center'}>
                                <Grid>
                                    <Typography variant="h4" sx={{ display: 'flex', color: globals.colors.lightRed, alignSelf: 'center', px: 6, textTransform: 'uppercase', fontWeight: 'bold' }}>Блог Секция</Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                    <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                        <BlogImageList />
                    </Grid>
                </Stack>
            </Grid> */}

                {/* Партньори */}
                <Grid container justifyContent='space-evenly' sx={{ mt: 5 }} justifyItems={'center'}>
                    <Stack>
                        <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    width: 1,
                                    height: 90,
                                }}>
                                <Grid container just sx={{ mt: 3 }} justifyContent={'center'}>
                                    <Grid>
                                        <Typography variant="h2" sx={{ display: 'flex', color: globals.colors.lightRed, textAlign: 'center', px: 6, fontWeight: 'bold', fontSize: 35 }}>Нашите Партньори</Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                        <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'} mt={3}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    width: 1,
                                    bgcolor: globals.colors.lightGray,
                                    borderRadius: 3,
                                    p: 3
                                }}>
                                <Grid container justifyContent={'space-around'} alignItems={'center'} px={3} spacing={8}>
                                    <Grid item>
                                        <img
                                            alt="Лого на партньор – Регионален съвет на СБНУ"
                                            title="Партньор – Регионален съвет на СБНУ"
                                            src="partner-regionalen-savet-sbnu.webp" loading="lazy" decoding="async" height={90} />
                                    </Grid>
                                    <Grid item>
                                        <img
                                            alt="Лого на партньор – Голямото изложение"
                                            title="Партньор – Голямото изложение"
                                            src="partner-golyamoto-izlozhenie.webp" loading="lazy" decoding="async" height={90} />
                                    </Grid>
                                    <Grid item>
                                        <img
                                            alt="Лого на партньор – WWF"
                                            title="Партньор – WWF"
                                            src="wwf.svg" loading="lazy" decoding="async" height={90} />
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Stack>
                </Grid>
            </Container>
        </div>
    );
}